export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));



// WEBPACK FOOTER //
// ./src/utils/sleep/index.js